import { IframeFileData } from '@/types';

interface IframeFileInput {
    id: string; // e.g. "index"
    name: string; // e.g. "index.html"
    subpath: string; // e.g. "/blogs" or "blogs"
}

/**
 * Generate iframe-backed FileData entries for a project.
 */
export function generateIframeFiles(projectId: string, baseUrl: string, files: IframeFileInput[]): IframeFileData[] {
    return files.map(file => {
        const normalizedSubpath = file.subpath.startsWith('/') ? file.subpath : `/${file.subpath}`;
        return {
            id: `${projectId}-${file.id}`,
            name: file.name,
            path: `${projectId}/${file.name}`,
            type: 'iframe',
            content: `${baseUrl}${normalizedSubpath}`,
        } as IframeFileData;
    });
}
